import { c as _c } from "react/compiler-runtime";
import { useEffect, useState, type FC, type EventHandler, type MouseEvent as SyntheticMouseEvent } from 'react';
import classnames from 'classnames';
import type { Categories } from '@sbt-web/category-utils';
import { CategoryID } from '@sbt-web/network/types';
import { AllCategoriesModal, ArrowDown, Button, Category as CategoryIcon } from '@sbt-web/ui';
import { useAppSelector } from '@/reducers/common';
import { getOrCreatePulse } from '@/tools/tracking/utils';
import { countFilters } from './count_filters';
import classes from './category-selector.module.scss';
const filtersButtonClickEvent = {
  type: 'Click',
  object: {
    type: 'UIElement',
    '@id': 'sdrn:subito:listing:search:element:filters-button',
    name: 'Mobile Filters Button',
    elementType: 'Button'
  }
};
type Props = {
  categoryList: Categories;
  categoryIndex: number;
  onCategoryChange: (opts: CategoryInfo) => void;
  onFiltersButtonClick: EventHandler<SyntheticMouseEvent>;
};
type CategoryInfo = {
  key: CategoryID;
  label: string;
};
export const CategorySelector: FC<Props> = t0 => {
  const $ = _c(31);
  const {
    categoryList,
    categoryIndex,
    onCategoryChange,
    onFiltersButtonClick
  } = t0;
  const filterCount = useAppSelector(_temp);
  const [dialogOpened, setDialogOpened] = useState(false);
  const t1 = categoryList[categoryIndex].id as CategoryID;
  const t2 = categoryList[categoryIndex];
  let t3;
  if ($[0] !== t1 || $[1] !== t2.label) {
    t3 = {
      key: t1,
      label: t2.label
    };
    $[0] = t1;
    $[1] = t2.label;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [category, setCategory] = useState(t3);
  let t4;
  let t5;
  if ($[3] !== categoryIndex || $[4] !== categoryList) {
    t4 = () => {
      setCategory({
        key: categoryList[categoryIndex].id,
        label: categoryList[categoryIndex].label
      });
    };
    t5 = [categoryList, categoryIndex];
    $[3] = categoryIndex;
    $[4] = categoryList;
    $[5] = t4;
    $[6] = t5;
  } else {
    t4 = $[5];
    t5 = $[6];
  }
  useEffect(t4, t5);
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setDialogOpened(true);
    };
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const handleDialogOpen = t6;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      setDialogOpened(false);
    };
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const handleDialogClose = t7;
  let t8;
  if ($[9] !== onFiltersButtonClick) {
    t8 = e => {
      getOrCreatePulse()?.queueEvent(filtersButtonClickEvent);
      onFiltersButtonClick(e);
    };
    $[9] = onFiltersButtonClick;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const onMobileFilterClick = t8;
  let t9;
  if ($[11] !== onCategoryChange) {
    t9 = selectedCategory => {
      if (selectedCategory) {
        onCategoryChange(selectedCategory);
        setCategory({
          key: selectedCategory.key,
          label: selectedCategory.label
        });
      }
    };
    $[11] = onCategoryChange;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const handleSelectedCategory = t9;
  const t10 = category?.key;
  let t11;
  if ($[13] !== dialogOpened || $[14] !== handleSelectedCategory || $[15] !== t10) {
    t11 = <AllCategoriesModal show={dialogOpened} onClose={handleDialogClose} setCategoryInput={handleSelectedCategory} assetsBase={process.env.NEXT_PUBLIC_ASSETS_BASE_URL} categoryId={t10} />;
    $[13] = dialogOpened;
    $[14] = handleSelectedCategory;
    $[15] = t10;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  let t13;
  let t14;
  let t15;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = [classes["button-category"]];
    t13 = <CategoryIcon className={classes["btn-category-icon-left"]} />;
    t14 = <ArrowDown className={classes["btn-category-icon-right"]} />;
    t15 = classnames("button-text", classes["button-category-text"]);
    $[17] = t12;
    $[18] = t13;
    $[19] = t14;
    $[20] = t15;
  } else {
    t12 = $[17];
    t13 = $[18];
    t14 = $[19];
    t15 = $[20];
  }
  const t16 = category?.label ?? "Tutte le categorie";
  let t17;
  if ($[21] !== t16) {
    t17 = <div className={classes["button-category-container"]}><Button design="outline" onClick={handleDialogOpen} classes={t12} iconLeft={t13} iconRight={t14}><span className={t15}>{t16}</span></Button></div>;
    $[21] = t16;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = [classes["filter-button"]];
    $[23] = t18;
  } else {
    t18 = $[23];
  }
  const t19 = `Filtri${filterCount > 0 ? ` +${filterCount}` : ""}`;
  let t20;
  if ($[24] !== onMobileFilterClick || $[25] !== t19) {
    t20 = <Button design="solid" classes={t18} size="medium" onClick={onMobileFilterClick}>{t19}</Button>;
    $[24] = onMobileFilterClick;
    $[25] = t19;
    $[26] = t20;
  } else {
    t20 = $[26];
  }
  let t21;
  if ($[27] !== t11 || $[28] !== t17 || $[29] !== t20) {
    t21 = <>{t11}{t17}{t20}</>;
    $[27] = t11;
    $[28] = t17;
    $[29] = t20;
    $[30] = t21;
  } else {
    t21 = $[30];
  }
  return t21;
};
function _temp(t0) {
  const {
    search
  } = t0;
  let customFilterCount = 0;
  if (search.qso) {
    customFilterCount = 1;
  }
  if (search.includeShippableOnly) {
    customFilterCount = customFilterCount + 1;
  }
  if (search.includeUrgent) {
    customFilterCount = customFilterCount + 1;
  }
  return countFilters(search.filters) + customFilterCount;
}